"use client";

import { Box, Circle, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useGetSimulationTemplatesQuery } from "@/store/slices/apiSlice";
import CircleLoader from "@/components/common/ActionLoader";
import { formatDuration } from "@/lib/utils";
import AddExperienceDialog from "@/components/dialogs/tenants/experiences/AddExperienceDialog";
import { useState } from "react";

const dummyTemplates = [
  {
    id: "template-001",
    name: "Template Name",
    description:
      "Template Description: [ Dummy Text ] Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-002",
    name: "Template Name",
    description:
      "Template Description: [ Dummy Text ] Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-003",
    name: "Template Name",
    description:
      "Template Description: [ Dummy Text ] Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
];

const SimulationTemplates = () => {
  const navigate = useNavigate();
  const [openAddExperience, setOpenAddExperience] = useState(false);
const [selectedTemplate, setSelectedTemplate] = useState(null);
  const {
    data: simulationTemplateList,
    isLoading,
    error,
  } = useGetSimulationTemplatesQuery();

  const templates = simulationTemplateList?.response?.data || [];
  const handleRemoveTemplate = (template) => {
    console.log("Remove template:", template);
  };
  const handleCreateFromTemplate = (template) => {
    navigate(`/tenants/campaigns/experiences/edit`, {
      state: {
        templateId: template?._id,
        templateData: template,
      },
    });
  };
  return (
    <div className="min-h-screen  px-6 py-6 text-neutral-100">
      <header className="mb-10">
        <h1 className="mb-5 text-3xl font-bold tracking-tight">
          Simulation Templates
        </h1>

        <p className="max-w-5xl text-sm font-semibold text-neutral-100/85">
          Explore reusable templates to quickly create experiences with
          pre-defined structures, interactions, and customizable settings.
        </p>
      </header>

      <div className="grid grid-cols-1 gap-7 md:grid-cols-2 xl:grid-cols-3">
        <CircleLoader loading={isLoading} size={64} />
        {/* {templates.map((template) => (
          <TemplateCard
            key={template.id}
            template={template}
            onCreate={() => handleCreateFromTemplate(template)}
            onRemove={() => handleRemoveTemplate(template)}
          />
        ))} */}
        {Array.isArray(templates) && templates.length > 0 ? (
          templates.map((template) => (
            // <TemplateCard
            //   key={template._id}
            //   template={template}
            //   // selected={selectedTemplateId === template._id}
            //   // onClick={() => setSelectedTemplateId(template._id)}
            //   onCreate={() => setOpenAddExperience(true)}
            //   // onCreate={() => handleCreateFromTemplate(template)}
            //   onRemove={() => handleRemoveTemplate(template)}
            // />
            <TemplateCard
              key={template._id}
              template={template}
              onCreate={() => {
                setSelectedTemplate(template);
                setOpenAddExperience(true);
              }}
              onRemove={() => handleRemoveTemplate(template)}
            />
          ))
        ) : (
          <p className="text-sm text-neutral-100/60 text-center">No templates found.</p>
        )}
      </div>
      {/* <AddExperienceDialog
        open={openAddExperience}
        onClose={() => setOpenAddExperience(false)}
        // templateId={templateId}
        // templateData={templateData}
      /> */}
      <AddExperienceDialog
        open={openAddExperience}
        onClose={() => {
          setOpenAddExperience(false);
          setSelectedTemplate(null);
        }}
        templateId={selectedTemplate?._id}
        templateData={selectedTemplate}
        from="/simulation-templates"
      />
    </div>
  );
};

const TemplateCard = ({ template, onCreate, onRemove }) => {
  return (
    <div className="rounded-md border border-brand-17 bg-[#1E426B]/80 p-4 shadow-lg">
      <div className="mb-7 flex h-[150px] items-center justify-center rounded bg-[#10243A]">
        <Box className="h-16 w-16 text-neutral-100/35" />
      </div>

      <h2 className="mb-4 text-2xl font-bold text-neutral-100">
        {template.name}
      </h2>

      <p className="mb-4 text-sm font-medium leading-relaxed text-neutral-100/90">
        {template.description}
      </p>

      <div className="mb-9 flex flex-wrap gap-3">
        <span className="rounded-md bg-[#355D88] px-4 py-2 text-xs font-semibold text-neutral-100/90">
          Approx Duration: {formatDuration(template.duration_time)}
        </span>

        <span className="rounded-md bg-[#355D88] px-4 py-2 text-xs font-semibold text-neutral-100/90">
          Difficulty: {template.difficulty}
        </span>
      </div>

      <div className="flex flex-wrap gap-4">
        <Button
          type="button"
          onClick={onCreate}
          className="h-10 flex-1 rounded-md bg-brand-21 text-sm font-bold text-neutral-100 hover:bg-brand-22"
        >
          Create from Template
        </Button>

        {/* <Button
          type="button"
          variant="outline"
          onClick={onRemove}
          className="h-10 flex-1 rounded-md border-[#555B6C] bg-transparent text-sm font-bold text-[#FF4D5D] hover:bg-[#2A1010] hover:text-[#FF4D5D]"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Remove
        </Button> */}
      </div>
    </div>
  );
};

export default SimulationTemplates;
